module.exports = __webpack_public_path__ + "img/wenduji.587c5700.png";